export default __webpack_public_path__ + "static/media/rpage.bcb76d58.png";